import { ROUTE_CONFIG } from "@/config/Routes/routes.config";

export const EStandalonePages = {
  LANDING: '/',
  PARENT_PATH: '/customers',
  APPROVED_PRODUCTS: `/customers/${ROUTE_CONFIG.SMART_COOLER_PRODUCTS.path}`,
} as const

export const MAGIC_COOKIES = {
  SID: 'sid',
  SIG: 'sig',
};

export const MAGIC_URL_HEADERS = {
  SID: 'x-gw-magic-sid',
  SIG: 'x-gw-magic-sig',
};

export const SUBAPP_CONFIGS = {
  kooick: {
    name: 'kooick',
    profile: 'Kooick Fusion',
  },
  smartcafe: {
    name: 'smartcafe',
    profile: 'Smart Cafe',
  },
};

export const STANDALONE_CONSTANTS = {
  ACCESS_ERROR_MODAL: {
    TITLE: 'Access Error',
    DESCRIPTION:
      'We couldn’t verify your access. Please go back to Seed and open this page again.',
    INFO_BUTTON: 'OK',
  },
  SESSION_EXPIRED_MODAL: {
    TITLE: 'Session Expired',
    DESCRIPTION:
      'Your session has expired. Please go back to Seed and open this page again.',
    INFO_BUTTON: 'OK',
  },
  SESSION_NOT_UPDATED_MODAL: {
    TITLE: 'Session Not Updated',
    DESCRIPTION:
      'The new link is no longer valid. We’ll keep your current session open.',
    INFO_BUTTON: 'OK',
  },
  PRODUCTS_LOAD_ERROR_MODAL: {
    TITLE: 'Unable to load products',
    UNEXPECTED_ERROR_DESCRIPTION:
      'We couldn’t load your approved products. Please refresh this page or try again from Seed.',
    API_ERROR_DESCRIPTION:
      'We couldn’t load your approved products. Please try again later or contact support.',
    INFO_BUTTON: 'OK',
  },
  SESSION_CONFLICT_MODAL: {
    TITLE: 'Session Conflict',
    DESCRIPTION:
      'An active session is already open. Do you want to switch to this new session?',
    CONFIRM_BUTTON: 'Switch to new',
    CANCEL_BUTTON: 'Keep current',
  },
};

export const APPROVED_PRODUCTS_PROPS = {
  SEARCH: {
    LEGACY_ID_PLACEHOLDER: 'Legacy Id',
    BARCODE_PLACEHOLDER: 'Barcode',
    PRODUCT_NAME_PLACEHOLDER: 'Product Name',
  },
  COLUMNS: {
    LEGACY_ID: 'Legacy Id',
    PRODUCT_NAME: 'Product Name',
    PRODUCT_IMAGE: 'Product Image',
    ACTIVE: 'Active',
    TRAINED_BARCODES: 'Trained Barcodes',
  },
};
